import moment from "moment";
import React from "react";
import { Col, Modal, ModalBody } from "reactstrap";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopTimePicker, LocalizationProvider } from "@mui/x-date-pickers";

import { ReactComponent as CloseIcon } from "../../../../../../assets/img/svg/CloseIcon.svg";

import CustomChip from "views/pages/manage/common/customChip/CustomChip";
import CustomCopyToClipboard from "views/pages/manage/common/ACopyToClipboard/CustomCopyToClipboard";
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2";
import AAutoComplete from "views/pages/manage/common/form-fields-mui/AAutoComplete";
import TestSyllabus from "../../testsListView/TestSyllabus";

import { getTestMediumDisplayValue } from "../../testsListView/constant";
import { minimumOnlineDate } from "../../academicTest/BasicForm";
import { isDatePassed } from "../helper";

import { timepickerStyle } from "../../academicTimetable/academicTimetableListView/TimeSelectionForm";
import commonStyles from "../../common/commonStyles.module.css";
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

const minimumStartDate = (testData) => {
  return isDatePassed(testData?.testScheduleStartDate || testData?.startDate)
    ? new Date()
    : moment(testData?.startDate || testData?.testScheduleStartDate);
};

const EditTestFromCalendar = ({
  isOpen,
  onClose,
  testData,
  saveEditedTestDetails,
  roomsDropdown,
  timeTableEndOn,
}) => {
  const [isShowSyllabus, setIsShowSyllabus] = React.useState(false);
  const [editedFields, setEditedFields] = React.useState(
    testData?.mode === "Offline"
      ? {
          testDate: testData?.testDate,
          testStartTime: testData.testStartTime,
          testEndTime: testData.testEndTime,
          room: testData.room,
          isItemEdited: false,
        }
      : {
          onlineTestDate: testData?.onlineTestDate || testData.testDate,
          onlineTestEndDate: testData.onlineTestEndDate,
          isItemEdited: false,
        }
  );
  //   const [editAttachedTest, setAttachedTest] = React.useState("");

  const getFormattedDate = (date) => {
    return new moment(date).format("DD MMM YYYY");
  };

  const minOnlineEndDate = (onlineTestDate, testData) => {
    const testDateWith3Days = moment(moment(onlineTestDate), "DD-MM-YYYY").add(
      2,
      "days"
    );

    const testEndDate = moment(
      testData?.endDate || testData?.testScheduleEndDate
    );
    const endOn = moment(timeTableEndOn);

    if (testDateWith3Days <= testEndDate && testDateWith3Days <= endOn)
      return testDateWith3Days;
    else if (testEndDate <= testDateWith3Days && testEndDate <= endOn)
      return testEndDate;
    else return endOn;
  };

  const updateFormField = (name, value) => {
    setEditedFields((prev) => ({ ...prev, [name]: value, isItemEdited: true }));
  };

  const handleSave = () => {
    if (
      testData.mode === "Offline" &&
      moment(editedFields.testStartTime)?.isSameOrAfter(
        moment(editedFields.testEndTime)
      )
    ) {
      failureToast("Start time should be less than end time");
      return;
    }

    if (editedFields.isItemEdited)
      saveEditedTestDetails(testData, editedFields);
    onClose();
  };

  const isDisable =
    testData.mode === "Online" && editedFields.onlineTestEndDate === "";

  return (
    <Modal
      size="lg"
      isOpen={isOpen}
      toggle={onClose}
      style={{ width: "500px" }}
    >
      <ModalBody>
        <div className="d-flex justify-content-between align-items-start mb-1">
          <div className="heading-4 label-color text-bold">
            {testData?.testType}
          </div>
          <CloseIcon onClick={() => onClose()} />
        </div>
        <div className="mb-3">
          <CustomChip textColor="#262626" bgColor={"#F5F5F5"}>
            <span>{testData?.testName}</span>
            <CustomCopyToClipboard textToCopy={testData?.testName} />
          </CustomChip>
          {testData?.isTimeTableEvent && (
            <CustomChip
              text="Branch test"
              textColor="#183DD3"
              bgColor="#CCD9FC"
              style={{ marginLeft: "1rem" }}
            />
          )}
        </div>

        {testData?.mode === "Offline" ? (
          <div className="mb-2 d-flex align-items-center">
            <span className="regular-large-bold text-bold color-dark mr-1">
              Test Date:{" "}
            </span>
            <div>
              <CustomDatePickerV2
                InputFontSize="15px"
                placeHolder="Select date"
                value={editedFields?.testDate}
                handler={(i, date) => updateFormField("testDate", date)}
                style={datePickerBorderlessStyles}
                minDate={minimumStartDate(testData)}
                maxDate={testData?.endDate || testData?.testScheduleEndDate}
              />
            </div>
          </div>
        ) : (
          <>
            <div className="mb-1 d-flex align-items-center flex-nowrap">
              <span className="regular-large-bold text-bold color-dark mr-1">
                Test Start Date:{" "}
              </span>
              <div>
                <CustomDatePickerV2
                  InputFontSize="15px"
                  placeHolder="Select start date"
                  value={editedFields?.onlineTestDate}
                  handler={(i, date) => {
                    updateFormField("onlineTestDate", date);
                    updateFormField("onlineTestEndDate", "");
                  }}
                  style={datePickerBorderlessStyles}
                  minDate={minimumStartDate(testData)}
                  maxDate={
                    (testData?.endDate &&
                      moment(testData?.endDate).subtract(1, "day")) ||
                    (testData?.testScheduleEndDate &&
                      moment(testData?.testScheduleEndDate).subtract(1, "day"))
                  }
                />
              </div>
            </div>{" "}
            <div className="mb-2 d-flex align-items-center">
              <span className="regular-large-bold text-bold color-dark mr-1">
                Test End Date:{" "}
              </span>
              <div>
                <CustomDatePickerV2
                  InputFontSize="15px"
                  placeHolder="Select end date"
                  value={editedFields?.onlineTestEndDate}
                  handler={(i, date) =>
                    updateFormField("onlineTestEndDate", date)
                  }
                  style={datePickerBorderlessStyles}
                  // minDate={testData?.testDate}
                  minDate={minimumOnlineDate(
                    { value: "Online" },
                    editedFields?.onlineTestDate
                  )}
                  maxDate={minOnlineEndDate(
                    editedFields?.onlineTestDate,
                    testData
                  )}
                />
              </div>
            </div>
          </>
        )}

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Mode:{" "}
          </span>
          {testData?.mode}
        </div>

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Test Format:{" "}
          </span>
          {testData?.format}
        </div>

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Result Date:{" "}
          </span>
          {getFormattedDate(testData?.resultDate)}
        </div>

        {testData?.mode === "Offline" && (
          <div className="mb-2 d-flex justify-content-between align-items-center">
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <div className="d-flex justify-content-between align-items-center">
                <span className="regular-large-bold text-bold color-dark mr-1">
                  Start time:{" "}
                </span>
                {/* <div> */}
                <DesktopTimePicker
                  ampm={false}
                  value={moment(editedFields?.testStartTime)}
                  onChange={(value) => {
                    updateFormField("testStartTime", value);
                  }}
                  sx={{ ...timepickerStyle, width: "60%" }}
                />
                {/* </div> */}
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <span className="regular-large-bold text-bold color-dark mr-1">
                  End Time:{" "}
                </span>
                {/* <div> */}
                <DesktopTimePicker
                  ampm={false}
                  value={moment(editedFields?.testEndTime)}
                  onChange={(value) => updateFormField("testEndTime", value)}
                  sx={{ ...timepickerStyle, width: "60%" }}
                  minTime={moment(editedFields?.testStartTime)}
                />
                {/* </div> */}
              </div>
            </LocalizationProvider>
          </div>
        )}

        <div className="mb-3">
          <span className="regular-large-bold text-bold color-dark">
            Test medium:{" "}
          </span>
          {testData?.mode === "Offline"
            ? "NA"
            : getTestMediumDisplayValue(testData?.testMediumType) || "-"}
        </div>

        <div className="mb-1 d-flex align-items-center">
          <span className="regular-large-bold text-bold color-dark mr-1">
            Room:{" "}
          </span>

          {testData?.mode === "Online" ? (
            "NA"
          ) : (
            <div style={{ width: "50%" }}>
              <AAutoComplete
                isMulti={false}
                items={roomsDropdown}
                currentValue={editedFields?.room}
                handleChange={(value) => updateFormField("room", value)}
              />
            </div>
          )}
        </div>

        <div className="d-flex justify-content-between align-items-center">
          <p
            className={`mb-0 ${commonStyles.link_button}`}
            onClick={() => setIsShowSyllabus(!isShowSyllabus)}
          >
            {isShowSyllabus ? "Hide Test Syllabus" : "View Test Syllabus"}
          </p>

          <AButton
            onClick={handleSave}
            variant="primary_filled"
            disabled={isDisable}
          >
            Edit test
          </AButton>
        </div>
        {isShowSyllabus && (
          <TestSyllabus testData={testData} isTimetable={true} />
        )}
      </ModalBody>
    </Modal>
  );
};

export default EditTestFromCalendar;

const datePickerBorderlessStyles = {
  input: {
    border: "none",
    height: "30px !important",
    width: "140px",
    boxShadow: "none",
    padding: "10px",
    background: "transparent",
    "--placeholder-color": "#00B0F5",
  },
};
